// src/shared/utils/edgeFunctionFehler.ts
//
// Fehler aus supabase.functions.invoke lesbar machen (XTAX GmbH & Co. KG).
//
// Antwortet eine Edge Function mit einem Fehlerstatus, liefert invoke einen
// FunctionsHttpError. Die eigentliche Meldung der Function steckt dann im
// Antwort-Body, erreichbar über error.context.json(). Dieser Helfer ist die
// eine Stelle dafür; vorher stand das Auslesen wortgleich im
// LohnscheinVersandModal und zweimal im DatevExchangeService (02.11.2026).

/**
 * Liest den Antwort-Body eines FunctionsHttpError. Liefert den geparsten
 * Inhalt unverändert oder null, wenn kein Body vorhanden oder er kein JSON ist.
 */
export async function leseEdgeFunctionFehler(error: unknown): Promise<any> {
  const context = (error as { context?: { json?: () => Promise<unknown> } })?.context;
  if (context && typeof context.json === 'function') {
    try {
      return await context.json();
    } catch (_e) {
      /* Body kein JSON */
    }
  }
  return null;
}

/**
 * Lesbare Fehlermeldung: zuerst error, dann message aus dem Antwort-Body,
 * sonst die Meldung des Fehlerobjekts, sonst der übergebene Rückfalltext.
 */
export async function edgeFunctionFehlertext(error: unknown, fallback: string): Promise<string> {
  const parsed = (await leseEdgeFunctionFehler(error)) as { error?: string; message?: string } | null;
  if (parsed?.error) return parsed.error;
  if (parsed?.message) return parsed.message;
  const message = (error as { message?: string })?.message;
  return message || fallback;
}
